import { styled } from '../../../common/ui'
import { theme } from '../theme'

export const Select = styled.select`
  border: 3px solid black;
  padding: 8px 20px 8px 8px;
  font-size: 16px;
  font-weight: bold;
  outline: 0;
  color: #000;
  background: ${theme.colors.grayLight};
  width: 100%;
  -webkit-appearance: none;

  -moz-appearance: none;

  background-image: url('data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2224%22%20height%3D%2216%22%20viewBox%3D%220%200%2024%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2212%201%209%206%2015%206%22%20%2F%3E%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23666%22%20points%3D%2212%2013%209%208%2015%208%22%20%2F%3E%0A%3C%2Fsvg%3E%0A');

  background-repeat: no-repeat;

  background-position: 100% 50%;

  &:hover {
    border: 3px solid ${theme.colors.blue};
  }
  &:active,
  &:focus {
    border: 3px solid ${theme.colors.blue};
    background: #fff;
  }

  &[data-has-error='1'] {
    border: 3px solid ${theme.colors.red};
  }
`
// https://stackoverflow.com/questions/7208786/how-to-style-the-option-of-an-html-select-element
export const Option = styled.option``
